module.exports = __webpack_public_path__ + "img/[色].35eafdf3.svg";